// ----------------------------------------------------------------------------

function adjust(elements: HTMLElement | HTMLElement[]): void {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    // Foreach Elements
    for (const element of elements) {
        // Get element dimension
        const width = element.offsetWidth;
        const height = element.offsetHeight;

        element.style.marginTop = '-' + height / 2 + 'px';
        element.style.marginRight = '0px';
        element.style.marginBottom = '0px';
        element.style.marginLeft = '-' + width / 2 + 'px';
    }
}

// ----------------------------------------------------------------------------

export { adjust };
